/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LandlordInputs */

const cs_enum_landlord = /** @type {(inputs: Enum_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronajímatel`)
};

const en_enum_landlord = /** @type {(inputs: Enum_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landlord`)
};

/**
* | output |
* | --- |
* | "Landlord" |
*
* @param {Enum_LandlordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_landlord = /** @type {((inputs?: Enum_LandlordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LandlordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_landlord(inputs)
	return cs_enum_landlord(inputs)
});